import {Component, inject, input} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {AutomaticRecordingStation} from "@models";
import {derivedAsync} from "ngxtension/derived-async";
import {Translations} from "@translations";
import {SimScenarioService, SimTrainingRoomService} from "@services";

@Component({
	selector: "sim-automatic-recording-session-card-station-content",
	imports: [MatIcon, TranslateModule],
	templateUrl: "./automatic-recording-session-card-station-content.component.html",
	styleUrl: "./automatic-recording-session-card-station-content.component.scss",
})
export class AutomaticRecordingSessionCardStationContentComponent {
	protected readonly T = Translations;

	readonly #roomService = inject(SimTrainingRoomService);
	readonly #scenarioService = inject(SimScenarioService);

	public readonly station = input.required<AutomaticRecordingStation>();

	protected readonly scenarioName = derivedAsync<string>(() => this.computeScenarioName(this.station()), {initialValue: ""});
	protected readonly roomName = derivedAsync<string>(() => this.computeRoomName(this.station()), {initialValue: ""});

	private async computeScenarioName(station: AutomaticRecordingStation) {
		if (station.scenario) {
			return station.scenario.name;
		} else {
			const scenario = await this.#scenarioService.getScenarioById(station.scenarioId);
			return scenario.name;
		}
	}

	private async computeRoomName(station: AutomaticRecordingStation) {
		if (station.room) {
			return station.room.name;
		} else {
			const room = await this.#roomService.getTrainingRoomById(station.roomId);
			return room.name;
		}
	}
}
